import apiClient from "./client";

/**
 * Error Logs API service
 * Global Admin only - views application error logs.
 */
export const errorLogsApi = {
  /**
   * Get paginated error logs with optional filters
   */
  async getLogs({
    fromDate = null,
    toDate = null,
    statusCode = null,
    exceptionType = null,
    page = 1,
    pageSize = 25,
  } = {}) {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (statusCode) params.append("statusCode", statusCode);
    if (exceptionType) params.append("exceptionType", exceptionType);
    params.append("page", page);
  params.append("pageSize", pageSize);

    return apiClient.get(`/errorlogs?${params.toString()}`);
  },

  /**
   * Get a specific error log by ID with full details
   */
  async getLog(id) {
    return apiClient.get(`/errorlogs/${id}`);
  },

  /**
   * Get error statistics
   */
  async getStats({ fromDate = null, toDate = null } = {}) {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
  if (toDate) params.append("toDate", toDate);

    return apiClient.get(`/errorlogs/stats?${params.toString()}`);
  },

  /**
   * Delete old error logs
   */
async cleanup(daysToKeep = 30) {
    return apiClient.delete(`/errorlogs/cleanup`, { daysToKeep });
  },
};

export default errorLogsApi;
